

export class Auth {
 userID = parseInt(localStorage.getItem('UserId'))
 isLogin = localStorage.getItem('IuDiToken')
 userName = localStorage.getItem('UserNameIuDi')
}
